module.exports = __webpack_public_path__ + "img/doc_download_icon.fb505651.svg";